













import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiTextarea from "../common/AsiTextarea";
import AsiRadioGroup from "../common/AsiRadioGroup";
import AsiTextField from "../common/AsiTextField";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import {AxiosError} from "axios";
import Order from "../../models/order/Order";
import OrderUpdate from "../../models/order/OrderUpdate";
import AsiDialogForm from "../common/AsiDialogForm.vue";

@Component({
	components: {AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class OrderUpdateDialogAdditionalInfos extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public order!: Order;

	private model: OrderUpdate | null = null;

	public created(): void {
		this.setOrderInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setOrderInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('order', {deep: true})
	private onOrderChanged(): void {
		this.setOrderInternal();
	}

	private setOrderInternal(): void {
		if (this.model === null) {
			this.model = new OrderUpdate(this.order);
		} else {
			this.model.setDetailModel(this.order);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$orderService.update(this.order.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}
}
